import { get, post } from '../request.js';

/**
 * 账号列表
 */
export async function queryAccountList(params) {
  return post('/api/account/page', params)
}

/**
 * 账号启用禁用
 */
export async function updateAccountStatus(params) {
  return post('/api/account/updateStatus', params)
}

/**
 * 赠送积分
 */
export async function giftPoints(params) {
  return post('/api/account/giftPoints', params)
}

/**
 * 删除账号
 */
export async function removeAccount(id) {
  return get(`/api/account/delete/${id}`)
}
/**
 * 新增账号
 */
export async function addAccount(params) {
  return post('/api/account/add', params)
}
/**
 * 编辑账号
 */
export async function editAccount(params) {
  return post('/api/account/edit', params)
}

/**
 * 编辑密码
 */
export async function editPassWord(params) {
  return post('/api/account/edit_password', params)
}




